import React, {FC, useState} from "react";
import * as fa from "@fortawesome/free-solid-svg-icons"
import {useApi} from "../api/APIContext";
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";
import { Input } from "@traas/lib/src/components/form/Input";
import {ValidationError} from "../api/api";
import {TASK_QUANTITY_TYPE_OTHER} from "../../../lib/src/api/dto/QuantityType"
import {Task} from "../../../lib/src/api/dto/Task";
import {QuantityType} from "../../../lib/src/api/dto/QuantityType"
import {Select} from "@traas/lib/src/components/form/Select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSquareCheck} from "@fortawesome/free-solid-svg-icons";
import {faSquare} from "@fortawesome/pro-light-svg-icons";

export const EditTaskModal: FC<{task: Task}> = ({task}) => {
  const {updateTaskDescriptionAndQuantity, quantityTypes} = useApi()

  const [name, setName] = React.useState(task.description)
  const defaultQuantityType = quantityTypes.find(qt => {
    const type = task.quantityType ?? TASK_QUANTITY_TYPE_OTHER
    return qt.id === type || qt.name === type
  })?.id ?? ""
  const [quantityType, setQuantityType] = React.useState<string>(defaultQuantityType)
  const [quantityAmount, setQuantityAmount] = React.useState<number|null>(task.quantityAmount ?? 0)
  const [quantityThickness, setQuantityThickness] = React.useState<number|null>(task.quantityThickness ?? 0)
  const [isImportant, setIsImportant] = useState<boolean>(task.isWorkorderRemarkImportant)
  const [note, setNote] = useState<string>(task.workorderRemark ?? '')
  const [errors, setErrors] = React.useState<string[]>([])
  const confirm = async () => {
    await updateTaskDescriptionAndQuantity(task, name, quantityType, quantityAmount ?? 0, quantityThickness ?? 0, note, isImportant)
      .catch(e => {
        if (e instanceof ValidationError) {
          setErrors(Object.values(e.errors).flat())
        }
        throw e
      })
  }

  return <form>
    <div className={"space-y-2"}>
      <div className={'flex-col space-y-2'}>
        <Select label={'Taak type'}
                options={Object.fromEntries(quantityTypes.map((qt: QuantityType) => [qt.id, qt.name]))}
                value={quantityType} onChange={setQuantityType}/>
        {quantityType !== TASK_QUANTITY_TYPE_OTHER &&
          <Input label={'Oppervlakte m²'} value={quantityAmount ?? 0} onChange={setQuantityAmount} type={'number'}/>}
        {quantityType !== TASK_QUANTITY_TYPE_OTHER &&
          <Input label={quantityTypes.find(qt => qt.id === quantityType)?.thicknessUnit === 'geen' ? 'Dikte'
            : `Dikte (${quantityTypes.find(qt => qt.id === quantityType)?.thicknessUnit})`}
                 value={quantityThickness ?? 0} onChange={setQuantityThickness} type={'number'}/>}
      </div>
      <Input label={'Omschrijving'} value={name} focus={true} onChange={setName} type={'text'}/>

      <div className={"grid grid-cols-1"}>
        <Input type={"textarea"} label={"Werkbon notities (optioneel)"} value={note} onChange={setNote}/>
      </div>
      <div className={'flex flex-row items-center px-3 space-x-2 rounded-sm hover:cursor-pointer hover:bg-brand-100 mr-40'} onClick={() => setIsImportant(!isImportant)}>
        <FontAwesomeIcon icon={isImportant ? faSquareCheck : faSquare} className={`text-lg ${isImportant  ? 'text-brand-900' : ''}`} />
        <div className={'py-1 px-1'}>
          <div className={'text-sm'}>Belangrijk</div>
          <div className={'text-xs'}>Hierbij legt de App extra nadruk op de ingevoerde notities</div>
        </div>
      </div>

      {errors.length > 0 && <div className={"text-red-600 text-sm"}>
        {errors.map((e, i) => <p key={i}>{e}</p>)}
      </div>}
      <ModalFooter icon={fa.faSave} text={"Opslaan"} onSubmit={confirm}/>
    </div>
  </form>
}
